module.exports = __webpack_public_path__ + "static/media/moblyx_normal_logo_blue_circle_white_m.92652205.png";